export const BX_HYBRID_SEARCH_EXPERIMENT = 'vx_desktop_bx_365_hybrid_listing';

export const EXPERIMENTS: string[] = [BX_HYBRID_SEARCH_EXPERIMENT];
